var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "drive-admin" },
    [
      _vm.owner
        ? [
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-back" },
                on: {
                  click: function ($event) {
                    _vm.owner = null
                    _vm.loadUsers()
                  },
                },
              },
              [_vm._v("返回人员空间")]
            ),
            _c("drive-explorer", {
              key: _vm.owner.ownerId,
              attrs: { "owner-id": _vm.owner.ownerId, "admin-view": "" },
            }),
          ]
        : [
            _vm._m(0),
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.tabChanged },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("el-tab-pane", {
                  attrs: { label: "人员空间", name: "people" },
                }),
                _c("el-tab-pane", {
                  attrs: { label: "全局文件搜索", name: "search" },
                }),
                _c("el-tab-pane", {
                  attrs: { label: "扩容审核", name: "quota" },
                }),
                _c("el-tab-pane", {
                  attrs: { label: "操作记录", name: "audit" },
                }),
              ],
              1
            ),
            _vm.tab === "people"
              ? [
                  _c(
                    "div",
                    { staticClass: "admin-toolbar" },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "按员工姓名或手机号搜索",
                        },
                        on: { input: _vm.searchPeople },
                        model: {
                          value: _vm.personKeyword,
                          callback: function ($$v) {
                            _vm.personKeyword = $$v
                          },
                          expression: "personKeyword",
                        },
                      }),
                      _c("el-button", { on: { click: _vm.loadUsers } }, [
                        _vm._v("刷新"),
                      ]),
                      _c("span", [_vm._v("部门管理人员优先显示")]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticClass: "space-grid",
                    },
                    _vm._l(_vm.users, function (user) {
                      return _c(
                        "button",
                        {
                          key: user.ownerId,
                          staticClass: "space-card",
                          on: {
                            click: function ($event) {
                              _vm.owner = user
                            },
                          },
                        },
                        [
                          _c("drive-avatar", {
                            attrs: { avatar: user.avatar, name: user.name },
                          }),
                          _c(
                            "strong",
                            [
                              _vm._v(_vm._s(user.name) + " "),
                              user.isManager
                                ? _c("el-tag", { attrs: { size: "mini" } }, [
                                    _vm._v("部门管理"),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("small", [
                            _vm._v(_vm._s(user.department || "未分配部门")),
                          ]),
                          _c("small", [_vm._v(_vm._s(user.phoneNumber))]),
                          _c("el-progress", {
                            attrs: {
                              percentage: Math.min(
                                100,
                                Math.round(
                                  ((Number(user.usedBytes) +
                                    Number(user.reservedBytes)) /
                                    Number(user.quotaBytes)) *
                                    100
                                )
                              ),
                              "show-text": false,
                            },
                          }),
                          _c("div", { staticClass: "space-usage" }, [
                            _vm._v(
                              _vm._s(_vm.fmt(user.usedBytes)) +
                                " / " +
                                _vm._s(_vm.fmt(user.quotaBytes))
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  !_vm.loading && !_vm.users.length
                    ? _c("el-empty", { attrs: { description: "未找到人员" } })
                    : _vm._e(),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.peoplePage,
                      total: _vm.peopleTotal,
                      "page-size": 24,
                      layout: "total,prev,pager,next",
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.peoplePage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.peoplePage = $event
                      },
                      "current-change": _vm.loadUsers,
                    },
                  }),
                ]
              : _vm._e(),
            _vm.tab === "search"
              ? [
                  _c(
                    "div",
                    { staticClass: "admin-toolbar" },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "搜索所有人员的文件名和目录名",
                        },
                        on: { input: _vm.searchAll },
                        model: {
                          value: _vm.globalKeyword,
                          callback: function ($$v) {
                            _vm.globalKeyword = $$v
                          },
                          expression: "globalKeyword",
                        },
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "按标签过滤所有人文件",
                          },
                          on: {
                            change: function ($event) {
                              _vm.filePage = 1
                              _vm.loadFiles()
                            },
                          },
                          model: {
                            value: _vm.tagId,
                            callback: function ($$v) {
                              _vm.tagId = $$v
                            },
                            expression: "tagId",
                          },
                        },
                        _vm._l(_vm.tags, function (tag) {
                          return _c("el-option", {
                            key: tag.id,
                            attrs: { value: tag.id, label: tag.name },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.loadFiles },
                          model: {
                            value: _vm.sort,
                            callback: function ($$v) {
                              _vm.sort = $$v
                            },
                            expression: "sort",
                          },
                        },
                        _vm._l(_vm.sorts, function (s) {
                          return _c("el-option", {
                            key: s.value,
                            attrs: { value: s.value, label: s.label },
                          })
                        }),
                        1
                      ),
                      _c("el-button", { on: { click: _vm.loadFiles } }, [
                        _vm._v("搜索"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      attrs: { data: _vm.files },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "文件/目录", "min-width": "300" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("strong", [_vm._v(_vm._s(row.name))]),
                                  _c("drive-matches", {
                                    attrs: {
                                      row: row,
                                      keyword: _vm.globalKeyword,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2523633560
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "ownerName",
                          label: "所属人员",
                          width: "150",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "大小", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      row.kind === "DIR"
                                        ? "目录"
                                        : _vm.fmt(row.fileSize)
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1243931442
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "标签", "min-width": "160" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return _vm._l(row.tags, function (tag) {
                                  return _c(
                                    "el-tag",
                                    { key: tag.id, attrs: { size: "mini" } },
                                    [_vm._v(_vm._s(tag.name))]
                                  )
                                })
                              },
                            },
                          ],
                          null,
                          false,
                          722863002
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createdAt",
                          label: "创建时间",
                          width: "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.enterOwner(row)
                                        },
                                      },
                                    },
                                    [_vm._v("进入所属空间")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1734233332
                        ),
                      }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.filePage,
                      total: _vm.fileTotal,
                      "page-size": 50,
                      layout: "total,prev,pager,next",
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.filePage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.filePage = $event
                      },
                      "current-change": _vm.loadFiles,
                    },
                  }),
                ]
              : _vm._e(),
            _vm.tab === "quota"
              ? [
                  _c("el-button", { on: { click: _vm.loadQuota } }, [
                    _vm._v("刷新申请"),
                  ]),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      attrs: { data: _vm.requests },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "ownerName",
                          label: "申请人",
                          width: "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "申请总容量", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _vm._v(_vm._s(_vm.fmt(row.requestedBytes))),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2022318472
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "reason",
                          label: "申请原因",
                          "min-width": "200",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [_vm._v(_vm._s(_vm.status(row.status)))]
                              },
                            },
                          ],
                          null,
                          false,
                          285560638
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "reviewNote",
                          label: "审核意见",
                          "min-width": "150",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createdAt",
                          label: "申请时间",
                          width: "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  row.status === "PENDING"
                                    ? [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.review(row, true)
                                              },
                                            },
                                          },
                                          [_vm._v("通过")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "danger",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.review(row, false)
                                              },
                                            },
                                          },
                                          [_vm._v("驳回")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3005476569
                        ),
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.tab === "audit"
              ? [
                  _c("el-button", { on: { click: _vm.loadAudit } }, [
                    _vm._v("刷新记录"),
                  ]),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      attrs: { data: _vm.audits },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "actorName", label: "操作人" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "ownerId", label: "所属空间用户ID" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [_vm._v(_vm._s(_vm.action(row.action)))]
                              },
                            },
                          ],
                          null,
                          false,
                          2342915966
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "detail",
                          label: "详情",
                          "min-width": "220",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createdAt",
                          label: "时间",
                          width: "190",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.audits.length === 100
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadAudit(
                                _vm.audits[_vm.audits.length - 1].id
                              )
                            },
                          },
                        },
                        [_vm._v("更早记录")]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm.error
              ? _c("el-alert", {
                  attrs: { title: _vm.error, type: "error", closable: false },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("div", [
        _c("h2", [_vm._v("文件管理")]),
        _c("p", [_vm._v("管理个人空间、文件分类、回收站及扩容申请")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }